export const videoTitleMaxLength = 120
